import { createAction, props } from '@ngrx/store';

const leaveOfferSuccess = createAction(
  '[Professional Leave Offer Store] Leave offer SUCCESS',
  props<{ professionalId: number }>()
);

export const ProfessionalLeaveOfferManagerActions = {
  leaveOfferSuccess,
};
